import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { CREATE_ACTIVITY } from '../../../../constants/ActivityCalendarConst';
import SearchBar from '../../../../shared/search-bar/Search-Bar';
import { EMPTY_PLACEHOLDER } from '../../../../utils/Constants';
import ActivityFilter from '../activity-filter/activityFilter';
import ActivityKebabMenu from '../activity-common-file/activity-kebab-menu';
import { selectedHotelCurrencySelector } from '../../../property/propertySlice';
import { useSelector } from 'react-redux';
import { currencies } from '../../../../constants/Currencies';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import moment from 'moment';

const ActivityCalendarListView = ({
  setDrawerIsOpen,
  setDrawerContentType,
  setActivitiesList,
  activitiesList,
  showFilter,
  setShowFilter,
  activityTypeList,
  setActivityTypeList,
  anchorEl,
  setAnchorEl,
  setActiveFilterName,
  showActiveFilterName,
  statusSubCategoryList,
  setStatusCategoryList,
  handleFilterResult,
  handleResetlist,
  availability,
  setAvailability,
  setLocationList,
  locationList,
  priceList,
  setPriceList,
  categoryList,
  setCategoryList,
  handleActions,
  filterOptions,
  totalSelectedFilters,
  handleShowFilter,
  handleSelectFilter,
  handleClose,
  page,
  rowsPerPage,
  onsetPage,
  onsetRowsPerPage,
  selectedDate,
  suppressViewClick,
  setSuppressViewClick,
  subFilterAnchorEl,
  hotelId,
}) => {
  const [searchText, setSearchText] = useState('');
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [filteredActivities, setFilteredActivities] = useState(activitiesList);
  const currencyCode = useSelector(selectedHotelCurrencySelector);
  const matchedCurrency = currencies?.filter((item) => item.code === currencyCode);
  const [currentPage, setCurrentPage] = useState(() => {
    const saved = sessionStorage?.getItem('activityCalendarPage');
    return saved !== null ? Number(saved) : page;
  });
  const [currentRowsPerPage, setCurrentRowsPerPage] = useState(() => {
    const saved = sessionStorage?.getItem('activityCalendarRows');
    return saved !== null ? Number(saved) : rowsPerPage;
  });

  const handlePageChange = (e, newPage) => {
    setCurrentPage(newPage);
    sessionStorage?.setItem('activityCalendarPage', newPage);
  };

  const handleRowsChange = (e) => {
    const r = parseInt(e?.target?.value, 10);
    setCurrentRowsPerPage(r);
    sessionStorage?.setItem('activityCalendarRows', r);
    setCurrentPage(0);
    sessionStorage?.setItem('activityCalendarPage', 0);

    if (e?.target instanceof HTMLElement) {
      e?.target?.blur();
    } else if (document?.activeElement instanceof HTMLElement) {
      document?.activeElement?.blur();
    }
  };

  useEffect(() => {
    if (selectedDate && activitiesList?.length) {
      const selectedMoment = moment(selectedDate).startOf('day');

      const filteredActivities = activitiesList.filter((activity) => {
        if (activity?.schedule?.alwaysActive) return true;

        const schedule = activity?.schedule;
        if (!schedule) return true;
        const type = schedule?.scheduleType;
        if (!type) return true;

        if (type === 'ONE_TIME') {
          if (!schedule?.oneTime?.date) return true;
          const date = moment(schedule?.oneTime?.date, 'DD-MM-YYYY').startOf('day');
          if (!date.isValid()) return true;
          return date.isSame(selectedMoment, 'day');
        }

        if (type === 'RECURRING') {
          const startDate = moment(schedule?.recurring?.startDate, 'DD-MM-YYYY').startOf('day');
          const endDate = moment(schedule?.recurring?.endDate, 'DD-MM-YYYY').endOf('day');
          if (startDate.isValid() && endDate.isValid()) {
            if (
              !selectedMoment.isBetween(
                startDate.clone().subtract(1, 'day'),
                endDate.clone().add(1, 'day'),
              )
            ) {
              return false;
            }
          }

          const { recurs, recursWeek = [], dates = [] } = schedule?.recurring || {};
          if (!recurs) return true;
          const selectedDay = selectedMoment.format('dddd').toUpperCase();
          const selectedDateNum = selectedMoment.date();

          if (recurs === 'DAY') return true;
          if (recurs === 'WEEK') return !recursWeek.length || recursWeek.includes(selectedDay);
          if (recurs === 'MONTH') {
            if (!dates.length || (dates.length === 1 && !dates[0])) return true;
            const dateNumbers = Array.isArray(dates)
              ? dates.flatMap((d) =>
                  d
                    .split(',')
                    .map((v) => Number(v.trim()))
                    .filter((n) => !isNaN(n)),
                )
              : [];
            if (!dateNumbers.length) return true;
            const isDateMatched = dateNumbers.includes(selectedDateNum);
            return (
              isDateMatched &&
              selectedMoment.isSameOrAfter(startDate, 'day') &&
              selectedMoment.isSameOrBefore(endDate, 'day')
            );
          }
          return true;
        }

        return true;
      });

      setFilteredActivities(filteredActivities);
    } else {
      setFilteredActivities([...activitiesList]);
    }
  }, [selectedDate, activitiesList]);

  useEffect(() => {
    setFilteredActivities(activitiesList);
  }, [activitiesList]);

  useEffect(() => {
    setCurrentPage(0);
    onsetPage(0);
    sessionStorage?.setItem('activityCalendarPage', '0');
  }, [hotelId, selectedDate]);

  const handleSearchText = (searchText) => {
    setSearchText(searchText);

    if (!searchText) {
      setFilteredActivities(activitiesList);
      return;
    }

    const filteredRows = activitiesList?.filter((item) => {
      return item?.name?.toLowerCase()?.includes(searchText?.toLowerCase());
    });
    onsetPage(0);
    setFilteredActivities(filteredRows);
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  return (
    <div className='row mx-auto d-flex'>
      <div className='card shadow'>
        <div className='mt-4 group-list-container'>
          <div className='col px-3 d-flex d-sm-block d-md-flex flex-wrap align-item-center justify-content-between'>
            <SearchBar
              type={CREATE_ACTIVITY}
              setSearchText={handleSearchText}
              onOpenDrawer={() => {
                setDrawerContentType(CREATE_ACTIVITY);
                setDrawerIsOpen(true);
              }}
              displayAddOrEdit='hide'
              visible={visible}
              setVisible={setVisible}
              popUp={popUp}
              setPopUp={setPopUp}
              displayText='Activities'
              module='ACTIVITY_CALENDAR'
              searchText={searchText}
              setSearch={setSearchText}
              actionMenuItems={[]}
            />
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-2'>
              <ActivityFilter
                showFilter={showFilter}
                filterOptions={filterOptions}
                setShowFilter={setShowFilter}
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                activityTypeList={activityTypeList}
                setActivityTypeList={setActivityTypeList}
                setActiveFilterName={setActiveFilterName}
                showActiveFilterName={showActiveFilterName}
                statusSubCategoryList={statusSubCategoryList}
                setStatusCategoryList={setStatusCategoryList}
                handleFilterResult={handleFilterResult}
                handleResetlist={handleResetlist}
                availability={availability}
                setAvailability={setAvailability}
                setLocationList={setLocationList}
                locationList={locationList}
                priceList={priceList}
                setPriceList={setPriceList}
                categoryList={categoryList}
                setCategoryList={setCategoryList}
                handleShowFilter={handleShowFilter}
                handleSelectFilter={handleSelectFilter}
                handleClose={handleClose}
                subFilterAnchorEl={subFilterAnchorEl}
                menuPositionOverride={{
                  anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
                  transformOrigin: { vertical: 'top', horizontal: 'right' },
                }}
                subMenuPositionOverride={{
                  anchorOrigin: { vertical: 'top', horizontal: 'left' },
                  transformOrigin: { vertical: 'top', horizontal: 'right' },
                }}
              />
            </div>
          </div>
          <div className='row mx-2 d-flex mt-4'>
            <TableContainer className='guest-list-table'>
              <Table className='list-table' aria-label='guest activity table'>
                <TableHead>
                  <TableRow className='border-white pointer'>
                    <TableCell className='w-5' align='center'></TableCell>
                    <TableCell className='w-30'>Activity Name</TableCell>
                    <TableCell className='w-25' align='left'>
                      Category
                    </TableCell>
                    <TableCell className='w-25' align='center'>
                      Price
                    </TableCell>
                    <TableCell className='w-15' align='center'>
                      Status
                    </TableCell>
                    <TableCell className='w-5' align='right'></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(currentRowsPerPage > 0
                    ? filteredActivities?.slice(
                        currentPage * currentRowsPerPage,
                        currentPage * currentRowsPerPage + currentRowsPerPage,
                      )
                    : filteredActivities
                  ).map((activity, index) => (
                    <TableRow
                      className='border-white pointer'
                      key={index}
                      onClick={() => {
                        if (suppressViewClick) {
                          setSuppressViewClick(false);
                          return;
                        }
                        handleActions(activity, 'View');
                      }}
                    >
                      <TableCell></TableCell>
                      <TableCell>{activity?.name || EMPTY_PLACEHOLDER}</TableCell>
                      <TableCell align='left'>
                        {activity?.categoryName || EMPTY_PLACEHOLDER}
                      </TableCell>
                      <TableCell align='center'>
                        {activity?.price
                          ? `${matchedCurrency?.[0]?.symbol || ''} ${activity?.price}`
                          : 'FREE'}
                      </TableCell>
                      <TableCell align='center'>
                        <div
                          className={
                            activity?.isActive
                              ? 'pill-active pill d-flex justify-content-center align-items-center'
                              : 'pill-inactive pill d-flex justify-content-center align-items-center'
                          }
                        >
                          <span className='ms-1'>{activity?.isActive ? 'Active' : 'Inactive'}</span>
                        </div>
                      </TableCell>
                      <TableCell className='kebab-menu' align='right'>
                        <ActivityKebabMenu
                          activityData={activity}
                          handleActions={handleActions}
                          setSuppressViewClick={setSuppressViewClick}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={filteredActivities?.length}
                      rowsPerPage={currentRowsPerPage}
                      page={currentPage}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handlePageChange}
                      onRowsPerPageChange={handleRowsChange}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityCalendarListView;
